// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__9C5vW","icon":"Pill_icon__-PSjC","text":"Pill_text__vhZkF"};